module.exports = __webpack_public_path__ + "static/img/7.158ec34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/7.png
// module id = /Clo
// module chunks = 0